import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ShieldAlert } from "lucide-react";

export function MfaGraceBanner() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const p = user?.mfa;
  if (!user || user.is_demo || !p?.required || p.enabled || pathname.startsWith("/security")) return null;
  const urgent = p.blocked || p.days_left <= 2;
  return (
    <div className={`px-4 sm:px-8 py-2 text-sm flex items-center justify-between gap-3 flex-wrap ${urgent ? "bg-red-700 text-white" : "bg-amber-100 text-amber-900"}`} data-testid="mfa-grace-banner">
      <div className="inline-flex items-center gap-2">
        <ShieldAlert className="w-4 h-4" />
        <span data-testid="mfa-grace-message">
          {p.blocked
            ? "Two-step verification is now required to view member information."
            : `Two-step verification becomes required for ${user.role === "clinician" ? "coaches" : "admins"} in ${p.days_left} day${p.days_left === 1 ? "" : "s"} — set it up now so you're not locked out.`}
        </span>
      </div>
      <Link to="/security" data-testid="mfa-grace-link" className={`text-xs font-semibold px-3 py-1.5 rounded-full ${urgent ? "bg-white text-red-800" : "bg-stone-900 text-white hover:bg-amber-700"}`}>Set up two-step verification</Link>
    </div>
  );
}
